export default class LazyImages {
    constructor() {
        this.images = Array.from(document.querySelectorAll('img[loading="lazy"]'))

        this.checkImages()

        window.addEventListener('scroll', () => {
            this.checkImages()
        })
    }

    isImageInViewport(image) {
        const rect = image.getBoundingClientRect()
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        )
    }

    isImagePartlyInViewport(image) {
        const rect = image.getBoundingClientRect()
        return (
            rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        )
    }

    updateImages() {
        this.images = Array.from(document.querySelectorAll('img[loading="lazy"]'))
        this.checkImages()
    }

    checkImages() {
        this.images.forEach((image) => {
            if (this.isImagePartlyInViewport(image)) {
                image.classList.add('u-img-loaded')
            }
        })
    }


}
